jQuery(document).ready(function ($) {
    $(document).on('click', '.main_request', function(e){
        e.preventDefault();
        var data = {
            action: 'main_request'
        }
        $.ajax({
            type: "POST",
            url: script_settings.ajax_url,
            dataType: 'JSON',            
            data: data,
            beforeSend: function (xhr) {
            //   console.log(xhr);
            },
            error: function (error) {
              console.log('error: ' + error);
            },
            success: function (response) {
              console.log(response.key);
            // $('.response-body').text(response);
            },
            complete: function (rsp) {
            //   console.log(rsp);
            }
        });
    })
});
  